export default {
    GANANCIALES: 'Bienes gananciales',
    PARTICIPACION: 'Participación',
    SEPARACION: 'Separación de bienes'
};
